import React from 'react';
import { Link } from 'react-router-dom';

const BASE_CLASSES = 'inline-flex items-center justify-center px-6 py-3 text-sm sm:text-base font-medium rounded-lg transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#a5400e]';
const VARIANTS = {
  outline: 'text-[#a5400e] border border-[#a5400e] hover:bg-[#a5400e] hover:text-white',
  solid: 'bg-[#a5400e] text-white shadow-md hover:bg-[#8a350b]',
};

const BackToHomeLink = ({ className = '', variant = 'outline', ...props }) => {
  const variantClasses = VARIANTS[variant] ?? VARIANTS.outline;
  const combinedClasses = `${BASE_CLASSES} ${variantClasses} ${className}`.trim();

  return (
    <Link to="/" className={combinedClasses} {...props}>
      Retour à l'accueil
    </Link>
  );
};

export default BackToHomeLink;
